import { API_PREFIX } from '../../config';
import { httpClient } from '../../utils';
import { type ApiResult } from '../apis.d';
import type {
  StaffProduct,
  OverviewData,
  SharingData,
  SevenDayDataList,
  ClientReportData,
  TagsListData,
  ClientlikeList,
  StationNameData,
} from '@feature-marketing-databoard/types';

// 营销数据看板-获取总客户数量与未添加标签的客户数量  客户简报
export const getClientReport = async <T>(params: T | any): Promise<ApiResult<ClientReportData>> =>
  await httpClient.post(`${API_PREFIX}api/applet/client/clientReport.do`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// 营销数据看板-数据总览
export const getOverview = async <T>(params: T | any): Promise<ApiResult<OverviewData>> =>
  await httpClient.post(`${API_PREFIX}api/applet/staff/report/get_overview.do`, params);

// 判断是否显示部门类型列表
export const isShowDeptTypeSelector = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/admin/ceb/is_firstLevel_dept.do`, params);
};

// 判断是不是浦发银行
export const getIsPfBank = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/station_card/isPfBank`, params);
};

// 判断是不是光大银行
export const isInWhiteList = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/admin/ceb/is_in_whiteList.do`, params);
};

// 查询小站名称
export const getStationName = async <T>(params: any): Promise<ApiResult<StationNameData>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/station/getStationName`, params);
};

// 营销数据看板-七日数据
export const getSevenDayData = async <T>(params: any): Promise<ApiResult<SevenDayDataList>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staff/report/seven_day_data.do`, params);
};

// 营销数据看板-分享内容统计
export const getSharingData = async <T>(params: any): Promise<ApiResult<SharingData>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staff/report/get_sharing.do`, params);
};

// 营销数据看板-客户偏好
export const getClientLikeData = async <T>(params: any): Promise<ApiResult<ClientlikeList>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staff/report/get_client_like.do`, params);
};

// 获取智能偏好标签
export const getSmartTagList = async <T>(params: any): Promise<ApiResult<TagsListData>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staff/report/list_customer_intelligent_preference.do`, params);
};

// 营销数据看板-获取总客户数量与未添加标签的客户数量  客户简报
export const getClientReportList = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/client/clientReport.do`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// 营销数据看板-新增客户人数 || 联系客户人数
export const getClientReportDetail = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/client/clientReportDetail.do`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// 营销数据看板-客户联系情况
export const getTouchReport = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/client/touchReport.do`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// 员工维度产品转化分析
export const getStaffProductRank = async <T>(params: any): Promise<ApiResult<StaffProduct>> => {
  return await httpClient.post(`${API_PREFIX}api/admin/ceb/staff_product_analysis.do`, params);
};

// 客户相关
export const getClients = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.post(`${API_PREFIX}api/applet/staffCustomerTag/listStaffCustomer`, params);
};

// 客户相关
export const getUnmarkedList = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/applet/client/no/tag/list.do`, { params });
};

// 获取产品快照id
export const getProductSnapshotId = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/admin/ceb/get_snapshotId.do`, { params });
};

// 获取产品类型
export const getFundType = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/admin/ceb/list_product_type.do`, { params });
};

// 获取产品列表
export const getFundList = async <T, U>(params: any): Promise<ApiResult<U>> => {
  return await httpClient.get(`${API_PREFIX}api/admin/ceb/list_product.do`, { params });
};
